import { render, staticRenderFns } from "./InfoWindow.vue?vue&type=template&id=2b116639&scoped=true"
import script from "./InfoWindow.vue?vue&type=script&lang=js"
export * from "./InfoWindow.vue?vue&type=script&lang=js"
import style0 from "./InfoWindow.vue?vue&type=style&index=0&id=2b116639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b116639",
  null
  
)

export default component.exports